import React, { useRef, forwardRef } from 'react';
import { ComboBox, Label as Label$1, Input as Input$1, Button as Button$1, Item as Item$1, Popover as Popover$1, ListBox, Section as Section$1, Header as Header$1, Collection as Collection$1, Text as Text$1 } from 'react-aria-components';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Combobox Root
// --------------------------------------------------------
// export interface ComboboxRootProps<T extends object>
//   extends Omit<
//       AriaComboBoxProps<T>,
//       | "children"
//       | "placeholder"
//       | "name"
//       | "label"
//       | "description"
//       | "errorMessage"
//     >,
//     AriaRenderProps<ComboBoxState<T>>,
//     AriaSlotProps {
//   /** The filter function used to determine if a option should be included in the combo box list. */
//   defaultFilter?: (textValue: string, inputValue: string) => boolean;
//   /** */
//   label?: string;
//   /** */
//   description?: string | null;
//   /** */
//   errorMessage?: string | null;
//   /** */
//   children?: React.ReactNode;
//   /** */
//   UNSAFE_className?: string;
// }

/** */
// const Root = forwardRef(
//   (
//     {
//       children,
//       UNSAFE_className,
//       ...props
//     }: ComboboxRootProps<{
//       label?: string;
//       description?: string | null;
//       errorMessage?: string | null;
//       children?: React.ReactNode;
//       UNSAFE_className?: string;
//     }>,
//     forwardedRef
//   ) => {
//     const innerRef = useRef<HTMLDivElement>(null);
//     useRefObjectAsForwardedRef(forwardedRef, innerRef);

//     return (
//       <AriaComboBox ref={innerRef} className={UNSAFE_className} {...props}>
//         {children}
//       </AriaComboBox>
//     );
//   }
// );
// @TODO: forwardRef
const Root = ({
  label,
  description,
  errorMessage,
  children,
  ...props
}) => {
  const innerRef = useRef(null);
  // useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(ComboBox, _extends({
    ref: innerRef
  }, props), children);
};
Root.displayName = "Root";
const Label = ({
  children,
  UNSAFE_className,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Label$1, _extends({
    className: UNSAFE_className
  }, props), children);
};
Label.displayName = "Label";
const Input = /*#__PURE__*/forwardRef(({
  children,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(Input$1, _extends({
    ref: innerRef,
    className: UNSAFE_className
  }, props), children);
});
const Button = ({
  children,
  UNSAFE_className,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Button$1, _extends({
    className: UNSAFE_className
  }, props), children);
};
Button.displayName = "Button";
const Item = /*#__PURE__*/forwardRef(({
  children,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(Item$1, _extends({
    ref: innerRef,
    className: UNSAFE_className
  }, props), children);
});
const Popover = /*#__PURE__*/forwardRef(({
  children,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(Popover$1, _extends({
    ref: innerRef,
    className: UNSAFE_className
  }, props), children);
});
const Listbox = /*#__PURE__*/forwardRef(({
  children,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(ListBox, _extends({
    ref: innerRef,
    className: UNSAFE_className
  }, props), children);
});
const Section = ({
  children,
  UNSAFE_className,
  ...props
}) => {
  useRef(null);
  // useRefObjectAsForwardedRef(forwardedRef, innerRef)
  return /*#__PURE__*/React.createElement(Section$1, _extends({}, props, {
    className: UNSAFE_className
  }), children);
};
Section.displayName = "Section";
const Header = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(Header$1, _extends({
    ref: innerRef
  }, props), children);
});
const Collection = ({
  children,
  ...props
}) => {
  // useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(Collection$1, props, children);
};
Collection.displayName = "Collection";
const Text = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    ref: innerRef
  }, props), children);
});
// --------------------------------------------------------
// Exports
Root.displayName = 'Combobox';
Label.displayName = 'Label';
Input.displayName = 'Input';
Button.displayName = 'Button';
Item.displayName = 'Item';
Popover.displayName = 'Popover';
Listbox.displayName = 'Listbox';
Section.displayName = 'Section';
Header.displayName = 'Header';
Collection.displayName = 'Collection';
Text.displayName = 'Text';
var Combobox = Object.assign(Root, {
  Label,
  Input,
  Button,
  Item,
  Popover,
  Listbox,
  Section,
  Header,
  Collection,
  Text
});

export { Combobox as default };
